namespace Matrix.Workflow {
    export class WorkflowMapColumns {
        static columnsKey = 'Workflow.WorkflowMap';
    }
}
